import React, { useState, useEffect } from 'react'
import Form from "view/component/Form";
import Modal from "react-bootstrap/Modal";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalTitle from "react-bootstrap/ModalTitle";
import ModalBody from "react-bootstrap/ModalBody";
import ModalFooter from "react-bootstrap/ModalFooter";
import {
    fetchSexs,
    getDistrics,
    getReligions,
    getJobs,
    packagingRef,
    nettoRef,
} from "view/portal/DataProvider";
import apiService from 'apiService';
import ALERT from 'view/component/Alert';
const AddProduct = (props) => {
    const removeClick = (i) => {
        let productx = [...props.product];
        productx.splice(i, 1);
        props.setproduct(productx);
    };
    const AddField = () => {
        let data = {
            ref_jenis_pangan_id: 1,
            trade_name: "",
            packaging_id: [],
            netto: "",
            netto_id: 1,
            composition: "",
            expired_in: 1,
            expired_unit: "hari",
            procution_scheme: "",
        };
        props.setproduct([...props.product, data]);
    };
    const [refPackaging, setPackagingRef] = useState([]);
    useEffect(() => {
        let isMounted = true; // note this flag denote mount status
        packagingRef().then((data) => {
            if (isMounted) setPackagingRef(data);
        });
        return () => {
            isMounted = false;
        }; // use effect cleanup to set flag false, if unmounted
    }, [refPackaging.length]);
    const [refNetto, setNettoRef] = useState([]);
    useEffect(() => {
        let isMounted = true; // note this flag denote mount status
        nettoRef().then((data) => {
            if (isMounted) setNettoRef(data);
        });
        return () => {
            isMounted = false;
        }; // use effect cleanup to set flag false, if unmounted
    }, [refNetto.length]);
    // console.log(refPackaging);

    //skema upload
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const handleFileChange = (i) => async (e) => {
        e.persist();
        // console.log(e);
        if (!validate(e.target.files[0])) return "";
        // console.log(validate(e.target.files[0]));

        setIsLoading(true);
        const fileBase64 = await toBase64(e.target.files[0]);
        let newArr = [...props.product]; // copying the old datas array
        newArr[i].procution_scheme = fileBase64; // replace e.target.value with whatever you want to change it to
        props.setproduct(newArr); // ??
    };
    const toBase64 = async (file) => {
        if (await file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = (error) => reject(error);
            });
        }
    };

    function validate(file, maxSize = 1000000, extension = "pdf,jpg,jpeg,png") {
        let thisError;
        const extensions = extension.split(",").map((validate) => validate);
        const arrFileName = file.name.split(".");
        const fileExtension = arrFileName[arrFileName.length - 1].toLowerCase();

        if (!extensions.includes(fileExtension)) {
            thisError = `extensi file harus ${extension}`;
            setError(thisError);
            return false;
        } else if (file.size > maxSize) {
            thisError = `ukuran file melebihi ${maxSize / 1024} KB`;
            setError(thisError);
            return false;
        } else {
            setError("");
            return true;
        }
    }
    //end skema upload

    // change state array produk
    const HandleChange = (index, name, val) => (e) => {
        if (name === undefined) {
            let newArr = [...props.product]; // copying the old datas array
            newArr[index][e.target.name] = e.target.value; // replace e.target.value with whatever you want to change it to
            props.setproduct(newArr); // ??
        } else if (val === undefined) {
            let newArr = [...props.product]; // copying the old datas array
            newArr[index][name] = e; // replace e.target.value with whatever you want to change it to
            console.log(newArr, newArr[index][name]);
            props.setproduct(newArr);
        } else {
            let newArr = [...props.product]; // copying the old datas array
            newArr[index][name] = val; // replace e.target.value with whatever you want to change it to
            console.log(index, name, val);
            props.setproduct(newArr);
        }
    };

    const getValue = (value) => {
        let data = [];
        if (value !== null) {
            value.map((dat, e) => {
                data.push(dat.value);
            });
            return data;
        }
    };

    //

    //post data
    // const postData = async (e) => {
    //     let param = [];
    //     product.map((data, index) => {
    //         param.push({
    //             pirt_perubahan_id: data.pirt_perubahan_id,
    //             ref_jenis_pangan_id: data.ref_jenis_pangan_id,
    //             trade_name: data.trade_name,
    //             packaging_id: getValue(data.packaging_id),
    //             netto: data.netto,
    //             netto_id: data.netto_id,
    //             composition: data.composition,
    //             expired_in: data.expired_in,
    //             expired_unit: data.expired_unit,
    //             procution_scheme: data.procution_scheme,
    //         });
    //     });
    //     let res = await apiService.post('/pirt/perubahan/addProduct', param);
    //     if (res.code === 200) {
    //         ALERT("success", "Berhasil Menyimpan Data ");
    //     } else {
    //         ALERT("error", "gagal menyimpan data");
    //     }
    // };
    //end post data
    return (
        <Modal {...props} size="lg" aria-labelledby="modal-rujukan">
            <ModalHeader closeButton>
                <ModalTitle id="modal-rujukan">Tambah Produk</ModalTitle>
            </ModalHeader>
            <ModalBody>
                <Form>
                    <div>
                        {props.product.map((data, i) => (
                            <div key={i}>
                                <div className="row">
                                    <div className="row col-md-10">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label
                                                    className="form-control-label"
                                                    htmlFor="example3cols1Input"
                                                >
                                                    Kategori Makanan
                                                </label>
                                                <select
                                                    type="text"
                                                    className="form-control"
                                                    id="example3cols1Input"
                                                    placeholder="Jenis Produk"
                                                    name="ref_jenis_pangan_id"
                                                    value={props.product[i].ref_jenis_pangan_id}
                                                    onChange={HandleChange(i)}
                                                >
                                                    <option value="">pilih</option>
                                                    {props.refjenispangan?.map((d, ky) => (
                                                        <option key={ky} value={d.value}>{d.label}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label
                                                    className="form-control-label"
                                                    htmlFor="example3cols2Input"
                                                >
                                                    Nama Produk
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="example3cols2Input"
                                                    placeholder="Nama Produk"
                                                    value={props.product[i].trade_name}
                                                    name="trade_name"
                                                    onChange={HandleChange(i)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <Form.ReactSelect
                                                label="Jenis kemasan"
                                                name="packaging_id"
                                                options={refPackaging}
                                                onChange={HandleChange(i, "packaging_id")}
                                                value={props.product[i].packaging_id}
                                                isMulti
                                                isClearable
                                            />
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group row ">
                                                <label
                                                    htmlFor="example-text-input"
                                                    className="col-lg-5  col-md-12 col-form-label form-control-label"
                                                >
                                                    Berat bersih/isi bersih
                                                  </label>
                                                <div className="col-lg-7  col-md-12">
                                                    <div className="input-group input-group">
                                                        <input
                                                            className="form-control"
                                                            type="number"
                                                            name="netto"
                                                            placeholder="berat dalam angka"
                                                            value={props.product[i].netto}
                                                            onChange={HandleChange(i)}
                                                        />
                                                        <select
                                                            name="netto_id"
                                                            placeholder="satuan"
                                                            className="form-control form-control"
                                                            value={props.product[i].netto_id}
                                                            onChange={HandleChange(i)}
                                                        >
                                                            <option value={""}>pilih</option>
                                                            {refNetto
                                                                ? refNetto.map((dat, key) => {
                                                                    return (
                                                                        <option key={key} value={dat.value}>
                                                                            {dat.label}
                                                                        </option>
                                                                    );
                                                                })
                                                                : ""}
                                                        </select>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label
                                                    className="form-control-label"
                                                    htmlFor="example3cols2Input"
                                                >
                                                    komposisi
                                                  </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="example3cols2Input"
                                                    placeholder="Komposisi"
                                                    name="composition"
                                                    value={props.product[i].composition}
                                                    onChange={HandleChange(i)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group row ">
                                                <label
                                                    htmlFor="example-text-input"
                                                    className="col-lg-5  col-md-12 col-form-label form-control-label"
                                                >
                                                    Masa simpan/kadaluwarsa
                                                 </label>
                                                <div className="col-lg-7  col-md-12">
                                                    <div className="input-group ">
                                                        <input
                                                            className="form-control "
                                                            type="number"
                                                            name="expired_in"
                                                            placeholder="lama kadaluarsa (dalam angka)"
                                                            value={props.product[i].expired_in}
                                                            onChange={HandleChange(i)}
                                                        />
                                                        <select
                                                            name="expired_unit"
                                                            className="form-control "
                                                            value={props.product[i].expired_unit}
                                                            onChange={HandleChange(i)}
                                                        >
                                                            <option value="">pilih waktu</option>
                                                            <option value="jam">jam</option>
                                                            <option value="hari">hari</option>
                                                            <option value="bulan">bulan</option>
                                                            <option value="tahun">tahun</option>
                                                        </select>
                                                    </div>
                            
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group row ">
                                                <label
                                                    htmlFor="example-text-input"
                                                    className="col-lg-5  col-md-12 col-form-label form-control-label"
                                                >
                                                   Skema Produksi
                                                 </label>
                                                <div className="col-lg-7  col-md-12">
                                                    <div className="input-group ">
                                                        <select
                                                            name="procution_scheme"
                                                            className="form-control "
                                                            value={props.product[i].procution_scheme}
                                                            onChange={HandleChange(i)}
                                                        >
                                                            <option value="">pilih skema</option>
                                                            <option value="1">Fermentasi</option>
                                                            <option value="2">Pemanggangan</option>
                                                            <option value="3">Pemberian gula</option>
                                                            <option value="4">Pencampuran dan Pengemasan</option>
                                                            <option value="5">Pengasaman</option>
                                                            <option value="6">Pengemasan / Pengepakan / Hanya Mengemas</option>
                                                            <option value="7">Pengeringan</option>
                                                            <option value="8">Penggaraman</option>
                                                            <option value="9">Penggorengan</option>
                                                            <option value="10">Pengukusan</option>
                                                            <option value="11">Penyangraian</option>
                                                            <option value="12">Perebusan</option>

                                                        </select>
                                                    </div>
                            
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div className="col-md-12">
                                            <Form.FileBrowser
                                                label="Skema Produksi (jpg, jpeg, png)"
                                                name="procution_scheme"
                                                onChange={handleFileChange(i)}
                                            />
                                        </div> */}
                                    </div>
                                    <div className="col-md-1">
                                        <button
                                            className="form-control btn btn-success"
                                            onClick={() => AddField()}
                                        >
                                            +
                                       </button>
                                    </div>
                                    <div className="col-md-1">
                                        <button
                                            className="form-control btn btn-danger"
                                            onClick={() => removeClick(i)}
                                        >
                                            x
                                      </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                        <div>
                        <button className="btn btn-danger" onClick={()=>props.onHide()}>
                                batal
                        </button>
                            <button className="btn btn-success" onClick={()=>props.onHide()}>
                                simpan
                        </button>
                        </div>
                    </div>
                </Form>
            </ModalBody>
        </Modal>
    );
};
export default AddProduct;